var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultipleChoiceItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D65C99",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "np_poll_14229_000000",
    transform: "translate(25.000000, 37.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.4767291 0 80 0 80 12.9855072 20.4767291 12.9855072"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.4767291 21.9130435 63.108261 21.9130435 63.108261 34.8985507 20.4767291 34.8985507"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20.4767291 43.0144928 41.3903108 43.0144928 41.3903108 56 20.4767291 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7033117,6.47652174 C12.7033117,10.0145855 9.85970807,12.8836522 6.35008732,12.8836522 C2.84352317,12.8836522 0,10.0145043 0,6.47652174 C0,2.93853913 2.84360361,0.0693913043 6.35008732,0.0693913043 C9.85978851,0.0693913043 12.7033117,2.93853913 12.7033117,6.47652174",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7033117,28.482087 C12.7033117,32.0201507 9.85970807,34.8892174 6.35008732,34.8892174 C2.84352317,34.8892174 0,32.0200696 0,28.482087 C0,24.940858 2.84360361,22.0717913 6.35008732,22.0717913 C9.85978851,22.0717913 12.7033117,24.9409391 12.7033117,28.482087",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7033117,49.2191304 C12.7033117,52.7571942 9.85970807,55.6262609 6.35008732,55.6262609 C2.84352317,55.6262609 0,52.757113 0,49.2191304 C0,45.6811478 2.84360361,42.812 6.35008732,42.812 C9.85978851,42.812 12.7033117,45.6811478 12.7033117,49.2191304",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoiceItem);
export default __webpack_public_path__ + "static/media/multipleChoiceItem.83cc0cd88ed8a57ee896de47efc37e77.svg";
export { ForwardRef as ReactComponent };